/*
 * Wmb, Worldline Merchant Billing.
 * Copyright (C) 2017-2019 Worldline
 * All Rights Reserved
 * This product is protected by copyright. Any copying or distribution
 * is forbidden without the agreement of Worldline.
 */
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';


@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
    DatePipe

    ]
})
export class CoreModule {
}
